export type NewFacilitiesKeyCopy = {
  copyNumber: string;
  hookNumber: string | null;
  facilitiesKeyCopyStatusId: string;
  createdByPersonId: string;
  issuedToPersonId: string | null;
}

export type UpdateFacilitiesKeyCopy = {
  hookNumber: string | null;
  facilitiesKeyCopyStatusId: string;
  updatedByPersonId: string;
  statusForPersonId: string |  null;
}

export type FacilitiesKeyCopiesFilterOptions = {
  page: number;
  pageSize: number;
  returnAll: boolean;
  facilitiesKeyId: string | null;
  facilitiesKeyCopyStatusId: string | null;
  buildingId: string | null;
  hookNumber: string | null;
  issuedToName: string | null;
}

export type FacilitiesKeyCopy = {
  id: string;
  copyNumber: string;
  hookNumber: string | null;
  facilitiesKeyCopyStatusId: string;
  facilitiesKeyCopyStatusName: string;
}

export type FacilitiesKeyCopyHistoriesFilterOptions = {
  page: number;
  pageSize: number;
  returnAll: boolean;
  facilitiesKeyCopyId: string | null;
  newFacilitiesKeyCopyStatusId: string | null;
  newHookNumber: string | null;
  issuedToName: string | null;
  returnedByName: string | null;
}

export type FacilitiesKeyCopyHistory = {
  id: string;
  previousFacilitiesKeyCopyStatusId: string | null;
  previousFacilitiesKeyCopyStatusName: string | null;
  newFacilitiesKeyCopyStatusId: string;
  newFacilitiesKeyCopyStatusName: string;
  previousHookNumber: string | null;
  newHookNumber: string | null;
  actionByPersonId: string;
  actionByPersonName: string;
  actionForPersonId: string | null;
  actionForPersonName: string | null;
  actionDate: Date;
}

export enum FacilitiesKeyCopyStatus {
  "Stored" = "22601C03-CCC8-4D1C-9242-7265365D5122",
  "Issued" = "637900F0-4901-4517-9537-CF636F850168",
  "Missing" = "79F2E89A-DF19-42BE-9F93-22EC2D920218",
  "Destroyed" = "1AAAF2F8-5DAE-4748-BCCD-550942001CAF"
}

export type FacilitiesKeyLocksFilterOptions = {
  page: number;
  pageSize: number;
  returnAll: boolean;
  facilitiesKeyId: string | null;
  lockType: string | null;
  buildingId: string | null;
  suite: string | null;
  room: string | null;
  lockIdentity: string | null;
}

export type NewFacilitiesKeyLock = {
  facilitiesLockId: string;
  notes: string | null;
  createdByPersonId: string;
}

export type UpdateFacilitiesKeyLock = {
  notes: string | null;
  lastModifiedByPersonId: string;
}

export type FacilitiesKeyLock = {
  id: string;
  facilitiesKeyId: string;
  keyNumber: string;
  facilitiesKeyTypeName: string;
  facilitiesLockId: string;
  lockType: string;
  buildingId: string | null;
  buildingName: string | null;
  spaceType: string | null;
  spaceIdentity: string | null;
  lockIdentity: string;
  notes: string | null;
  createdDate: Date;
  lastModifiedDate: Date;
}

export type NewFacilitiesKey = {
  keyNumber: string;
  facilitiesKeyTypeId: string;
  buildingId: string | null;
  buildingSpaceId: string | null;
  createdDate: Date;
}

export type FacilitiesKey = {
  id: string;
  keyNumber: string;
  facilitiesKeyTypeId: string;
  facilitiesKeyTypeName: string;
  numberOfKeyCopies: number;
  createdDate: Date;
  canBeDeleted: boolean;
}

export type FacilitiesKeysFilterOptions = {
  page: number;
  pageSize: number;
  returnAll: boolean;
  facilitiesKeyTypeId: string | null;
  facilitiesKeyCopyStatusId: string | null;
  hookNumber: string | null;
  buildingId: string | null;
  lockIdentity: string | null;
  issuedToName: string | null;
  issuedToPersonOrganizationCode: string | null;
}

export enum FacilitiesKeyType {
  "Grand Master" = "8C923579-BDE1-4BEC-B64C-305A77407F8A",
  "Suite Master" = "BFFA37CA-5E3B-4BD5-84E1-BEB63B191173",
  "Standard" = "D0693472-90A2-45FD-BD2E-D86D72B7A533"
}
